module.exports = __webpack_public_path__ + "img/borja.bc739f92.png";